// Feature permission constants. Must stay in sync with backend FeaturePermissions::ALL.

export const PERMISSIONS = {
  WORKLOG: 'worklog',
  REPORTS: 'reports',
  ADMIN_PANEL: 'admin_panel',
  PROJECT_SHARING: 'project_sharing',
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);